// removed by extract-text-webpack-plugin
module.exports = {"input":"qempo_input_input-emG_wiO","lightBlue":"qempo_input_lightBlue-1KidsJF","red":"qempo_input_red-rc_CQ61","yellow":"qempo_input_yellow-HB6UBIJ","orange":"qempo_input_orange-egWZN8R","radiusLess":"qempo_input_radiusLess-11kMvZQ","rightRadiusLess":"qempo_input_rightRadiusLess-2Kzl9wz","leftRadiusLess":"qempo_input_leftRadiusLess-2juoCCI","inputErrorLabel":"qempo_input_inputErrorLabel-2Snp8FB"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/styles/input.scss
// module id = 19
// module chunks = 0